import { theme } from '@xbto/design-system';
import { createTheme } from 'react-native-themesheet';
// https://github.com/eightyfive/react-native-themesheet
// @see lib/box.tsx
export const { createBox } = createTheme({}, theme.spacing);
